var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/multiply/insertMultiplyFromDeps.ts";
import "regenerator-runtime/runtime.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable no-await-in-loop */
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { getNode } from "../../../classifier-service";
import { isBimRefType, isBimType, isGroupType, nodeToApiTypeMap } from "../../../classifier-service/adapters";
export function insertMultiplyFromDeps(_x) {
  return _insertMultiplyFromDeps.apply(this, arguments);
}

function _insertMultiplyFromDeps() {
  _insertMultiplyFromDeps = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var dependenciesCheckedItems, currentClassifier, nextParentNode, nodes$, onSuccessItem, modelElementCheckedItem, groupCheckedItems, dynamicBaseGroups, leftItems, lastVersion, itemRef, node, parentGroupId, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dependenciesCheckedItems = _ref.dependenciesCheckedItems, currentClassifier = _ref.currentClassifier, nextParentNode = _ref.nextParentNode, nodes$ = _ref.nodes$, onSuccessItem = _ref.onSuccessItem;
            modelElementCheckedItem = dependenciesCheckedItems.filter(function (_ref2) {
              var type = _ref2.type;
              return isBimType(type) || isBimRefType(type) || type === 'DynamicGeneratedGroupNode' || type === 'DynamicBimElementReferenceNode';
            });

            if (modelElementCheckedItem.length && nextParentNode.type === 'UserClassifierGroupNode') {
              api.BimReference.createRefs.defaultContext({
                classifierId: currentClassifier.id,
                classifierVersion: currentClassifier.version,
                parentGroupId: nextParentNode.id,
                items: modelElementCheckedItem.map(function (item) {
                  var node = getNode(nodes$.getState(), item);

                  if (!node) {
                    return null;
                  }

                  var trueNode = 'element' in node ? node.element : node;
                  return {
                    id: trueNode.id,
                    type: nodeToApiTypeMap[trueNode.type],
                    sourceClassifierId: item.parentClassifierId,
                    sourceClassifierVersion: item.parentClassifierVersion,
                    sourceParentGroupId: (item === null || item === void 0 ? void 0 : item.sourceParentGroupId) || null
                  };
                }).filter(isNotEmpty)
              });
            }

            groupCheckedItems = dependenciesCheckedItems.filter(function (_ref3) {
              var type = _ref3.type;
              return isGroupType(type);
            });
            dynamicBaseGroups = groupCheckedItems.map(function (item) {
              var node = getNode(nodes$.getState(), item);

              if (!node) {
                return null;
              }

              return node.dynamicGroup;
            }).filter(isNotEmpty);

            if (dynamicBaseGroups.length > 0) {
              api.BimReference.createRefs.defaultContext({
                classifierId: currentClassifier.id,
                classifierVersion: currentClassifier.version,
                parentGroupId: nextParentNode.id,
                items: dynamicBaseGroups.map(function (node) {
                  return {
                    id: node.id,
                    type: nodeToApiTypeMap[node.type],
                    sourceClassifierId: node.parentClassifierId,
                    sourceClassifierVersion: node.parentClassifierVersion,
                    sourceParentGroupId: null
                  };
                }).filter(isNotEmpty)
              });
            } //TODO обенуть в bulk


            if (!groupCheckedItems.length) {
              _context.next = 21;
              break;
            }

            leftItems = _toConsumableArray(groupCheckedItems);
            lastVersion = currentClassifier.version;

          case 9:
            if (!(leftItems.length > 0)) {
              _context.next = 21;
              break;
            }

            itemRef = leftItems.shift();
            node = getNode(nodes$.getState(), itemRef);

            if (!node.dynamicGroup) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("continue", 9);

          case 14:
            parentGroupId = nextParentNode.type === 'UserClassifierNode' ? undefined : nextParentNode.id;
            _context.next = 17;
            return api.UserClassifierGroup.createGroupReference.defaultContext({
              classifierId: currentClassifier.id,
              parentClassifierVersion: lastVersion,
              sourceClassifierId: node.parentClassifierId,
              sourceClassifierVersion: node.parentClassifierVersion,
              sourceGroupId: node.id,
              parentGroupId: parentGroupId
            });

          case 17:
            result = _context.sent;
            lastVersion = result.parentClassifierVersion; // onSuccessItem && onSuccessItem(itemRef)

            _context.next = 9;
            break;

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _insertMultiplyFromDeps.apply(this, arguments);
}